import React, { Fragment } from "react";
import { Card } from "@lemonadetraining/web-ui";

const MyCard = (props) => {
  return (
    <Fragment>
      <Card className="shadow-none border-0 p-4">{props.children}</Card>
    </Fragment>
  );
};

export default MyCard;
